export const isLoggingIn = (state) => state.getIn(["authentication", "isLoggingIn"]);

export const isAuthenticated = (state) => state.getIn(["authentication", "isAuthenticated"]);

export const isCheckingAuth = (state) => state.getIn(["authentication", "isCheckingAuth"]);

export const errorMessage = (state) => state.getIn(["authentication", "errorMessage"]);
